import React from 'react';
import { convertToThousands, percentageValue } from '../../helpers/NumberFormatter';

export default function AbsoluteValue(props) {
    const { value, convert, digits, currency } = props;
    return <span title={value} className={props.className}>
        {convertToThousands(value, digits, currency)}  
    </span>    
}
